import Link from "./Link"
import Image from "./Image"

export default function Locality() {
    return (
            <Link
                href="localityMap"
                target="_blank"
            >
                <i>
                    <Image
                        src="location"
                        alt="location"
                    />
                </i>
                <span>BE 7904 Willaupuis (Hainaut)</span>
            </Link>
        )
}